const ReportNames = {
  WorkAndDiary: 'WorkAndDiary',
  Adjust: 'Adjust',
  Diary: 'Diary',
  AllKYWork: 'AllKYWork',
  AllAdjustWork: 'AllAdjustWork',
  AllResultWork: 'AllResultWork',
  AllKY: 'AllKY',
  GatePassageDaily: 'GatePassageDaily',
  GatePassageWeekly: 'GatePassageWeekly',
  AllCraneUse: 'AllCraneUse',
  CraneUseDaily: 'CraneUseDaily',
  CraneUseWeekly: 'CraneUseWeekly',
  CstmObayashiWorkSafety: 'CstmObayashiWorkSafety',
  AllMachineryInstruction: 'AllMachineryInstruction',
  MachineryUse: 'MachineryUse',
  HotWorkManager: 'HotWorkManager',
  HotWork: 'HotWork',
  AllOxygenLackPartnerCompany: 'AllOxygenLackPartnerCompany',
  EarlytimeWork: 'EarlytimeWork',
  OvertimeWork: 'OvertimeWork',
  EarlytimeNotify: 'EarlytimeNotify',
  OvertimeNotify: 'OvertimeNotify',
  AllFixedWorkDetailedStatementPayment: 'AllFixedWorkDetailedStatementPayment',
  AllUnfixedWorkDetailedStatementPayment:
    'AllUnfixedWorkDetailedStatementPayment',
  AllWorkDetailedStatementPayment: 'AllWorkDetailedStatementPayment',
  FixedWorkTotal: 'FixedWorkTotal',
  UnfixedWorkTotal: 'UnfixedWorkTotal',
  WorkTotal: 'WorkTotal',
  GatePassageMonthly: 'GatePassageMonthly',
  CraneUseMonthly: 'CraneUseMonthly',
  MonthWork: 'MonthWork',
  PrintoutPrev: 'PrintoutPrev',
  PrintoutPrev2: 'PrintoutPrev2',
  PrintSafetyDiary: 'PrintSafetyDiary',
  PrintSafetyDiaryList: 'PrintSafetyDiaryList',
  AllNishimatsuKy: 'AllNishimatsuKy',
  NishimatsuKNisshi: 'NishimatsuKNisshi',
  CstmGoyoField: 'CstmGoyoField',
  CstmGoyo: 'CstmGoyo',
  Ky: 'Ky',
  KyGoyo: 'KyGoyo',
  CraneGoyo: 'CraneGoyo',
  HighplaceGoyo: 'HighplaceGoyo',
  VehicleGoyo: 'VehicleGoyo',
  FireworkGoyo: 'FireworkGoyo',
  MatsuiSafety: 'MatsuiSafety',
  TaiseiSafety: 'TaiseiSafety',
  SeibuWorkCommon: 'SeibuWorkCommon',
  SeibuWorkRail: 'SeibuWorkRail',
  SeibuSafety: 'SeibuSafety',
  KSagyoyotei: 'KSagyoyotei',
  KNisshi: 'KNisshi',
  KJisshi: 'KJisshi',
  CstmObayashiAllAdjustWork: 'CstmObayashiAllAdjustWork',
  CstmObayashiAllResultWork: 'CstmObayashiAllResultWork',
  KKosuseiri: 'KKosuseiri',
  Saigaitok: 'Saigaitok',
  Nisshi: 'Nisshi',
  UchiawaseshoNippo: 'UchiawaseshoNippo',
  Nippo: 'Nippo',
  ShijiKy: 'ShijiKy',
  Anzenshiji: 'Anzenshiji',
  Shiji: 'Shiji',
  Takuma: 'Takuma',
  TaiseiSafety2: 'TaiseiSafety2',
  Shinchoku: 'Shinchoku',
  NishimatsuDNisshi: 'NishimatsuDNisshi',
  SeibuWorkCommonPart2: 'SeibuWorkCommonPart2',
  SeibuWorkRailPart2: 'SeibuWorkRailPart2',
  SeibuSafety2: 'SeibuSafety2',
  SeibuSafety3: 'SeibuSafety3',
  Geppo: 'Geppo',
  OkumuraUchiawase: 'OkumuraUchiawase',
  OkumuraNisshi: 'OkumuraNisshi',
  Ky1: 'Ky1',
  TakenakadobokuNisshi: 'TakenakadobokuNisshi',
  TakenakadobokuKy: 'TakenakadobokuKy',
  Tachiai: 'Tachiai',
  ToutetsuNisshiJR: 'ToutetsuNisshiJR',
  ToutetsuKyJR: 'ToutetsuKyJR',
  NakayamaNisshi: 'NakayamaNisshi',
  NakayamaKy: 'NakayamaKy',
  MitsuisumitomoNissi: 'MitsuisumitomoNissi',
  ZenitakaMeeting: 'ZenitakaMeeting',
  ZenitakaAnzen: 'ZenitakaAnzen',
  KumagaiUchiawase: 'KumagaiUchiawase',
  Uchiawase: 'Uchiawase',
  ShijiNisshi: 'ShijiNisshi',
  KawaguchiNisshi: 'KawaguchiNisshi',
  ObayashiAllAdjustWork: 'ObayashiAllAdjustWork',
  ObayashiAllResultWork: 'ObayashiAllResultWork',
  WorkAndDiary2: 'WorkAndDiary2',
  HpsNisshiL: 'HpsNisshiL',
  HpsNisshiS: 'HpsNisshiS',
  HpsKyL: 'HpsKyL',
  HpsKyS: 'HpsKyS',
  NkkTowerCraneMeetingForm: 'NkkTowerCraneMeetingForm',
  NkkVehicleMachineryMeetingForm: 'NkkVehicleMachineryMeetingForm',
  NkkTransportableCraneMeetingForm: 'NkkTransportableCraneMeetingForm',
  KgtNisshi: 'KgtNisshi',
  TakenakadobokuNisshiBasho: 'TakenakadobokuNisshiBasho',
  KtkNippo: 'KtkNippo',
  UkgNisshi: 'UkgNisshi',
  TouyouKy: 'TouyouKy',
  TouyouNisshi: 'TouyouNisshi',
  NakanofudouKy: 'NakanofudouKy',
  Cr577KyoritsuRaky: 'Cr577KyoritsuRaky',
  Cr576KyoritsuNisshi: 'Cr576KyoritsuNisshi',
  Cr578KonoikeA: 'Cr578KonoikeA',
  Cr579KonoikeB: 'Cr579KonoikeB',
  Cr136WorkAndDiary2: 'Cr136WorkAndDiary2',
  Cr660KumagaiUchiawase: 'Cr660KumagaiUchiawase',
  Cr680CstmGoyoD: 'Cr680CstmGoyoD',
  Cr681CstmGoyoK: 'Cr681CstmGoyoK',
  Cr682CivilKy: 'Cr682CivilKy',
  Cr683CivilNisshi: 'Cr683CivilNisshi',
  Cr684ToutetsuNisshi: 'Cr684ToutetsuNisshi',
  Cr685ToutetsuKy: 'Cr685ToutetsuKy',
  Cr686HonmagumiNisshi: 'Cr686HonmagumiNisshi',
  Cr687HonmagumiNisshiMeeting: 'Cr687HonmagumiNisshiMeeting',
  Cr688FkdNisshiK: 'Cr688FkdNisshiK',
  Cr689FkdKyK: 'Cr689FkdKyK',
  Cr690TekkenKy: 'Cr690TekkenKy',
  Cr692UkgAllWork: 'Cr692UkgAllWork',
  Cr693NishimatsuWorkAndDiary: 'Cr693NishimatsuWorkAndDiary',
  Cr694TokyuWorkAndDiary: 'Cr694TokyuWorkAndDiary',
  Cr695TouyouNisshiD: 'Cr695TouyouNisshiD',
  Cr629AndouhazamaNisshi: 'Cr629AndouhazamaNisshi',
  Cr630AndouhazamaKyPonchie: 'Cr630AndouhazamaKyPonchie',
  Cr696DainihondobokuWorkAndDiary: 'Cr696DainihondobokuWorkAndDiary',
  Cr697DainihondobokuAllKyWork: 'Cr697DainihondobokuAllKyWork',
  Cr598GoudakoumutenToukyoAnzenshiji: 'Cr598GoudakoumutenToukyoAnzenshiji',
  Cr599GoudakoumutenToukyoShinchoku: 'Cr599GoudakoumutenToukyoShinchoku',
  Cr800AsanumaWorkAndDiary: 'Cr800AsanumaWorkAndDiary',
  Cr801KoseikensetsuWorkAndDiary: 'Cr801KoseikensetsuWorkAndDiary',
  Cr802TouakensetsuWorkAndDiary: 'Cr802TouakensetsuWorkAndDiary',
  Cr803TaiseiSafety: 'Cr803TaiseiSafety',
  Cr804TaiseiSafety2: 'Cr804TaiseiSafety2',
  Cr805TobishimaKy: 'Cr805TobishimaKy',
  Cr806TokyuTetsudouDobokuWorkAndDiary: 'Cr806TokyuTetsudouDobokuWorkAndDiary',
  Cr807KumagaiAllKycWork: 'Cr807KumagaiAllKycWork',
  Cr808FudotetraWorkAndDiary: 'Cr808FudotetraWorkAndDiary',
  Cr809FudotetraAllKyWork: 'Cr809FudotetraAllKyWork',
  Cr810TodadouroWorkAndDiary: 'Cr810TodadouroWorkAndDiary',
  Cr811TaiseiSafety3: 'Cr811TaiseiSafety3',
  Cr812TaiseiKy: 'Cr812TaiseiKy',
  Cr813TokyuCnstKy: 'Cr813TokyuCnstKy',
  Cr814TaikiAllKyWork: 'Cr814TaikiAllKyWork',
  Cr815KgKenchikuWorkAndDiary: 'Cr815KgKenchikuWorkAndDiary',
  Cr316MitsuisumitomoNissiBashonashi: 'Cr316MitsuisumitomoNissiBashonashi',
  CR317SeibuWorkCommonPart3: 'CR317SeibuWorkCommonPart3',
  Cr818TekkenWorkAndDiary: 'Cr818TekkenWorkAndDiary',
  Cr819AndouhazamaKyMinisagyoTejyunsho: 'Cr819AndouhazamaKyMinisagyoTejyunsho',
  Cr820AndouhazamaKyUramenNashi: 'Cr820AndouhazamaKyUramenNashi',
  Cr821AndouhazamaKySetsumeisho: 'Cr821AndouhazamaKySetsumeisho',
  Cr822MorigumiWorkAndDiary: 'Cr822MorigumiWorkAndDiary',
  Cr823KajitaWorkAndDiary: 'Cr823KajitaWorkAndDiary',
  Cr824WorkSafeDiaryPs: 'Cr824WorkSafeDiaryPs',
  Cr825KyReportPs: 'Cr825KyReportPs',
  Cr826Renrakuchouseikiroku: 'Cr826Renrakuchouseikiroku',
  Cr827KYTetsudo: 'Cr827KYTetsudo',
  Cr828MaruhongumiSagyouUchiawase: 'Cr828MaruhongumiSagyouUchiawase',
  Cr829SatokogyoWorkAndDiary: 'Cr829SatokogyoWorkAndDiary',
  Cr830MeikoWorkAndDiary: 'Cr830MeikoWorkAndDiary',
  Cr831MeikoAllKyWork: 'Cr831MeikoAllKyWork',
  Cr832KajitaCraneMachineUse: 'Cr832KajitaCraneMachineUse',
  Cr833KajitaTowercraneUse: 'Cr833KajitaTowercraneUse',
  Cr834WorkAndDiary: 'Cr834WorkAndDiary',
  Cr835AllKyWork: 'Cr835AllKyWork',
  Cr138SignlessWorkAndDiary: 'Cr138SignlessWorkAndDiary',
  Cr336SeibuWorkRailPart3: 'Cr336SeibuWorkRailPart3',
  Cr837AllKyWork: 'Cr837AllKyWork',
  Cr838AndouhazamaAllCraneUse: 'Cr838AndouhazamaAllCraneUse',
  Cr839AndouhazamaMachineryInstruction: 'Cr839AndouhazamaMachineryInstruction',
  Cr840WorkAndDiary: 'Cr840WorkAndDiary',
  Cr841KgDobokuWorkAndDiary2: 'Cr841KgDobokuWorkAndDiary2',
  Cr842WorkAndDiary: 'Cr842WorkAndDiary',
  Cr843AllKyWork: 'Cr843AllKyWork',
  Cr844SafetyAndDiary: 'Cr844SafetyAndDiary',
};

export default ReportNames;



// WEBPACK FOOTER //
// ./src/utilities/reportNames.js